export default __webpack_public_path__ + "static/media/bitcoinPlusPlusLogo.cbe39684.png";